module.exports = __webpack_public_path__ + "img/exam_jan_2025_as96yjq9.0554ecc1.jpg";